import { updateKeyInStore } from 'App';
import { OtherIncomeStateValues, TProperty, updateKey } from '../slice';

export const uploadFields: IBaseField<
  keyof OtherIncomeStateValues | keyof TProperty
>[] = [
  {
    name: 'pleaseUploadSchK1OrForeignDocumentReportingYourShareOfIncomelosses',
    label:
      'Please upload Sch K-1 or foreign document reporting your share of income/losses',
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.income.otherIncome.values.doYouOwnAShareinterestInACorporationOrPartnershipwhetherUsOrForeign',
  },
  {
    name: 'pleaseUploadLlcRegistrationDocuments',
    label: 'Please upload LLC registration documents',
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.income.otherIncome.values.areYouTheSoleOwnerOfAUsLlc',
  },
  {
    name: 'duringYearDidYouReceiveInheritanceOrGiftsFromANonUSPersonProvideDocument',
    label: 'Please provide details',
    type: 'upload',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    predicate: (value) => value === 'yes',
    dependentOn:
      'taxQuestionnaire.income.otherIncome.values.duringYearDidYouReceiveInheritanceOrGiftsFromANonUSPerson',
  },
  {
    name: 'uploadAwardLetter',
    label: 'Upload award letter',
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.income.otherIncome.values.didYouReceiveAStipendOrFellowshipGrant',
  },
  {
    name: 'pleaseUploadForm1099MiscOrForeignDocumentReportingRoyaltiesReceived',
    label:
      'Please upload form 1099-MISC or foreign document reporting royalties received',
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.income.otherIncome.values.didYouReceiveRoyalitieseitherUsOrForeign',
  },
  {
    name: 'pleaseUploadForm1099G',
    label: 'Please upload form 1099-G',
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.income.otherIncome.values.didYouReceiveARefundOrUnemploymentIncomeFromAUsStateInYear',
  },
  {
    name: 'pleaseUploadSupportingDocuments',
    label: 'Please upload supporting documents if any',
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.income.otherIncome.values.didYouReceiveNonUsMonetaryBenefitsOfAnyKind',
  },
  {
    name: 'pleaseUploadForm1099C',
    label: 'Please upload form 1099C',
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.income.otherIncome.values.doYouHaveACancelledieForgivenDuringTheYearDebtThatYouDidNotPayBack',
  },
  {
    name: 'pleaseUploadSupportingDocumentsdidYouHaveLottery',
    label: 'Please upload supporting documents',
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.income.otherIncome.values.didYouHaveLotterygamblingWinningOrLawsuitSettlementDuringTheFilingYear',
  },
  {
    name: 'firstGovernmentStimulusPackage',
    label: 'First government stimulus package',
    subLabel: () => (
      <p>
        Please Upload Notice 1444 (preferred)If you don't have this - it's ok.
        Please make sure to complete the amount below.
      </p>
    ),
    type: 'upload',
    predicate: (value) =>
      value === 'First stimulus check for $1200' ||
      value === 'I received both stimulus checks',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.income.otherIncome.values.didYouReceiveTheFirstStimulusOrBothStimulusPayments',
  },
  {
    name: 'secondGovernmentStimulusPackage',
    label: 'Second government stimulus package',
    subLabel: () => (
      <p>
        Please Upload Notice 1444 (preferred) If you don't have this - it's ok.
        Please make sure to complete the amount below.
      </p>
    ),
    type: 'upload',
    predicate: (value) =>
      value === 'Second stimulus check for $600' ||
      value === 'I received both stimulus checks',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.income.otherIncome.values.didYouReceiveTheFirstStimulusOrBothStimulusPayments',
  },
];
